import request from '@/utils/request'

export const setLogin = (params) => {
  return request.post("/login", params);
};

// 获取验证码
export const getVerifyCode = (params) => {
  return request.post("/common/send-sms", params);
};

// 退出登录
export const quitLogin = (params) => {
  return request.post("/logout", { params });
};

export const setLoginCode = (params) => {
  return request.post("/login/sms", params);
};
export const getLogoImg = (params) => {
  return request.post("/login/web-info", params);
};